import { PartyType } from '@parties/src/types';
import { useQuery } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';

interface AnvaFlowsInsurancesResponse {
  items: AnvaFlowsInsurance[];
}
export interface AnvaFlowsInsurance {
  id: string;
  name: string;
  branche: string;
  primary_branch: string;
}

export const getAnvaFlowsInsurances = async (entityType: PartyType) => {
  const { data, isError } = await wgApi.get<AnvaFlowsInsurancesResponse>(
    `/v1/api/anvaflows/supported-insurances`,
    {
      query: { entity_type: entityType }, // Add entityType as query parameter
    },
  );
  if (isError) throw new Error();
  return data;
};

const getUseAnvaFlowsInsurances = (entityType: PartyType) => [
  'flow-config',
  'anva',
  'insurances',
  entityType,
];

export const useAnvaFlowsInsurances = (entityType: PartyType) => {
  return useQuery(
    getUseAnvaFlowsInsurances(entityType),
    () => getAnvaFlowsInsurances(entityType),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
};
